import { useState } from "react";
import axios from "axios";
import { Lock } from "lucide-react";
import { API, TOKEN_KEY, formatApiErrorDetail } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export const AdminLogin = ({ onLogin }) => {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const { data } = await axios.post(`${API}/auth/login`, { password });
      localStorage.setItem(TOKEN_KEY, data.token);
      onLogin();
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen grid place-items-center px-5 bg-[radial-gradient(120%_80%_at_50%_10%,#3B1A72_0%,#170B2E_55%,#0D051C_100%)]" data-testid="admin-login-page">
      <form onSubmit={submit} className="w-full max-w-sm bg-white rounded-[22px] p-8 shadow-[0_40px_80px_-30px_rgba(0,0,0,.8)]" data-testid="admin-login-form">
        <img src="/assets/logo-dark.jpg" alt="Davis Infinite Care Corporation" className="w-28 rounded-xl mx-auto mb-6" />
        <h1 className="font-display text-3xl text-center text-[#1C1430] mb-1">Admin sign in</h1>
        <p className="text-center text-sm text-[#5E5672] mb-6">Manage events and read messages.</p>
        <Label htmlFor="admin-password" className="font-bold text-[#1C1430]">Password</Label>
        <Input
          id="admin-password"
          type="password"
          autoFocus
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="mt-1.5 h-12 bg-[#F6F1FD] border-[#E4DCF2] focus-visible:ring-[#7B3FE4]"
          data-testid="admin-password-input"
        />
        {error && <p className="text-[#C2264B] text-sm font-bold mt-3" data-testid="admin-login-error">{error}</p>}
        <button type="submit" disabled={busy || !password} className="btn btn-purple w-full justify-center mt-6" data-testid="admin-login-submit-button">
          <Lock /> {busy ? "Signing in…" : "Sign in"}
        </button>
        <a href="/" className="block text-center text-sm text-[#5A2D9C] font-bold mt-5 hover:underline" data-testid="admin-back-to-site-link">← Back to site</a>
      </form>
    </div>
  );
};
